<template>
	<div @click="startEditing" style="min-height: 25px">
		<span v-if="!isEditing" class="editable-text"> {{ internalDisplayValue }} </span>

		<component v-else :is="isSelect ? 'b-form-select' : 'b-form-input'" v-model="internalValue" size="sm"
			:ref="`input-${_uid}`" @blur="stopEditingAndSave" @change="isSelect ? stopEditingAndSave() : null"
			@keyup.enter="isSelect ? null : stopEditingAndSave()" :options="options" :type="inputType" :step="step"
			:max="max" :min="min">
		</component>
	</div>
</template>

<script>
// EditableCell.vue
export default {
	props: {
		value: {
			type: [String, Number],
			required: true,
		},
		step: {
			type: String,
			required: false,
			default: () => { return "" }
		},
		max: {
			type: String,
			required: false,
			default: () => { return "" }
		},
		min: {
			type: String,
			required: false,
			default: () => { return "" }
		},
		// Nuova prop per definire il tipo di input
		type: {
			type: String,
			default: "text", // 'text', 'select', 'number', ecc.
		},
		// Nuova prop per le opzioni, se type è 'select'
		options: {
			type: Array,
			default: () => [],
		},
		// Nuova prop per il campo da visualizzare nel caso di 'select'
		displayKey: {
			type: String,
			default: null, // Chiave nell'oggetto options per la visualizzazione
		},
		disabled: {
			type: Boolean,
			default: true,
		},
	},
	data() {
		return {
			isEditing: false,
			internalValue: this.value,
		};
	},
	computed: {
		isSelect() {
			return this.type === "select";
		},
		inputType() {
			// Se non è una select, usa il 'type' come tipo di input HTML
			return this.isSelect ? null : this.type;
		},
		// Calcola il valore da visualizzare quando non si è in modalità di modifica
		internalDisplayValue() {
			if (this.isSelect && this.options.length > 0) {
				// Se è una select, cerca il testo corrispondente al valore
				const selectedOption = this.options.find((opt) => opt.value == this.internalValue);
				// Se displayKey è impostato, usa quello, altrimenti usa 'text'
				return selectedOption ? (this.displayKey ? selectedOption[this.displayKey] : selectedOption.text) : this.internalValue;
			}
			return this.internalValue; // Altrimenti, mostra il valore normale
		},
	},
	watch: {
		value(newVal) {
			this.internalValue = newVal;
		},
	},
	methods: {
		// ... (startEditing e stopEditingAndSave rimangono gli stessi)
		startEditing() {
			if (!this.isEditing && this.disabled) {
				this.isEditing = true;
				this.$nextTick(() => {
					// Controlla se il ref esiste prima di chiamare focus
					if (this.$refs[`input-${this._uid}`]) {
						this.$refs[`input-${this._uid}`].focus();
					}
				});
			}
		},
		stopEditingAndSave() {
			if (this.isEditing) {
				this.isEditing = false;
				// Emette l'evento 'update'
				this.$emit("update", this.internalValue);

				// Opzionale: emetti un evento di blur specifico per la tabella genitore
				this.$emit("blur", this.internalValue);
			}
		},
	},
};
</script>

<style scoped>
/* Stile per indicare che la cella è cliccabile (opzionale) */
.editable-text {
	cursor: pointer;
	padding: 2px 5px;
	border: 1px solid transparent;
}
</style>
